package top.wcpe.allincore.ui.web

import top.wcpe.allincore.ui.runtime.render.layer.DrawTracePhase

internal enum class WebRenderDiagnosticSeverity {
    ERROR,
    WARNING,
    INFO,
}

internal data class WebRenderDiagnostic(
    val code: String,
    val severity: WebRenderDiagnosticSeverity,
    val message: String,
    val sessionId: String,
    val surfaceGeneration: Int,
    val capabilityKey: String,
    val resourceKey: String,
    val phase: DrawTracePhase?,
    val sequence: Int,
)

internal fun interface WebRenderDiagnosticSink {
    fun emit(diagnostic: WebRenderDiagnostic): Boolean
}

internal fun canonicalWebResourceKey(resource: String): String = resource.substringBefore('?').substringBefore('#')

internal fun defaultWebRenderDiagnosticSink(): WebRenderDiagnosticSink =
    DeduplicatingWebRenderDiagnosticSink { diagnostic ->
        console.warn(
            "${diagnostic.code}：${diagnostic.message}；能力=${diagnostic.capabilityKey}；资源=${diagnostic.resourceKey}",
        )
    }

internal class DeduplicatingWebRenderDiagnosticSink(
    private val consumer: (WebRenderDiagnostic) -> Unit,
) : WebRenderDiagnosticSink {

    private val counts = mutableMapOf<DiagnosticKey, Int>()

    override fun emit(diagnostic: WebRenderDiagnostic): Boolean {
        val key = diagnostic.key()
        val count = (counts[key] ?: 0) + 1
        counts[key] = count
        if (count != 1) {
            return false
        }
        consumer(diagnostic)
        return true
    }

    fun duplicateCount(diagnostic: WebRenderDiagnostic): Int = counts[diagnostic.key()] ?: 0

    fun clear() {
        counts.clear()
    }

    private fun WebRenderDiagnostic.key(): DiagnosticKey = DiagnosticKey(
        sessionId,
        surfaceGeneration,
        code,
        capabilityKey,
        resourceKey,
        phase,
        if (code == RESOURCE_MISSING_CODE) sequence else -1,
    )

    private data class DiagnosticKey(
        val sessionId: String,
        val surfaceGeneration: Int,
        val code: String,
        val capabilityKey: String,
        val resourceKey: String,
        val phase: DrawTracePhase?,
        val sequenceClass: Int,
    )

    private companion object {
        const val RESOURCE_MISSING_CODE = "WEB_RENDER_RESOURCE_MISSING"
    }
}
